import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import MainLayout from './layout/MainLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import MockUserSelect from './pages/MockUserSelect';
import AdminLogin from './pages/AdminLogin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminPanel from './pages/AdminPanel';
import Dashboard from './pages/Dashboard';
import Animals from './pages/Animals';
import AnimalForm from './pages/AnimalForm';
import Transfers from './pages/Transfers';
import DeceasedAnimals from './pages/DeceasedAnimals';
import News from './pages/News';
import MissingAnimals from './pages/MissingAnimals';
import ReportMissing from './pages/ReportMissing';
import Profile from './pages/Profile';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/mock-users" element={<MockUserSelect />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <MainLayout />
                </PrivateRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="animals" element={<Animals />} />
              <Route path="animals/new" element={<AnimalForm />} />
              <Route path="animals/deceased" element={<DeceasedAnimals />} />
              <Route path="animals/:id" element={<AnimalForm />} />
              <Route path="transfers" element={<Transfers />} />
              <Route path="news" element={<News />} />
              <Route path="missing-animals" element={<MissingAnimals />} />
              <Route path="missing-animals/report" element={<ReportMissing />} />
              <Route path="profile" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
